import { ConnectButton } from "@src/components"
import { useSliceContext } from "@components/SliceProvider"
import { useEffect } from "react"
import { useAccount } from "wagmi"

export const CONNECT_VIEW = () => {
  const { setModalView } = useSliceContext()
  const { address: account } = useAccount()

  useEffect(() => {
    if (account) {
      setModalView({ name: "" })
    }
  }, [account])

  return (
    <>
      <div className="sl-pb-6 sl-text-center">
        <h1 className="sl-fonts">Before moving on</h1>
      </div>
      <div className="sl-text-center">
        <p className="sl-pb-6">
          You need to connect your wallet to complete this action
        </p>
      </div>
      <ConnectButton />
    </>
  )
}

export default CONNECT_VIEW
